import Link from "next/link";
import {twMerge} from "tailwind-merge";

export default function FreelancerLink({link = "/", title, iconClasses = "", parentClasses = ""}) {
    return (
        <Link href={link} className={twMerge("rounded-[1.25rem] px-4 py-4 lg:pt-[1.125rem] lg:pb-[1.063rem] hover:brightness-75", parentClasses)}>
            <i className={`hidden lg:inline-block text-2xl ${iconClasses}`} />
            <p className="flex items-center justify-between lg:mt-5 ">
                <span className="text-white">
                     <i className={`lg:hidden ml-3.5 text-2xl ${iconClasses}`} />
                    {title}
                </span>
                <i className="icon-simple-arrow-left text-pol-orange-dark" />
            </p>
        </Link>
    )
}
